<style lang="less">
.ivu-carousel-active{
  button{
    background:var(--primary) !important;
  }
}
</style>

<template>
    <Carousel style="width:100%;overflow:hidden;" v-model="carouselIndex" loop :autoplay="images.length > 1" :autoplay-speed="10000" >
        <CarouselItem v-for="image in images" :key="image">
          <div>
            <img :src="image"  style="filter:brightness(0.8);width:100%;" />
            <div v-if="!data.images || data.images.length == 0" style="position:absolute;color:#fff;font-size:20px;left:calc(50% - 50px);top:calc(50% - 10px);text-shadow:1px 1px 1px #333">效果图未上传</div>
            </div>
        </CarouselItem>
    </Carousel>


</template>

<script>
import mixinResponsable from '@/mixins/responsable';
import {mapGetters} from 'vuex';
import {setTimeout} from 'timers';
import moment from 'moment';
moment.locale('zh-CN');
export default {
  name: 'images',
  panelInfo: {
    name: '效果图',
    minWidthSpan: 2,
    weatherData: {
      realtime: {},
    },
  },
  data() {
    return {
      carouselIndex: 0,
      time: moment().format('HH:mm:ss'),
    };
  },
  mixins: [mixinResponsable],
  props: ['data', 'env'],
  computed: {
    project() {
      return this.data || {};
    },
    images() {
      return this.project.images && this.project.images.length > 0?this.project.images:['https://inbgz-1257839135.cos.ap-shanghai.myqcloud.com/assets/project_tmpl.jpg'];
    },
  },
};
</script>

<style lang="less" scoped>
img{
  filter:hue-rotate(-20deg);
}

.pd-note{
  position: absolute;
  left:10px;
  top:10px;
  right:10px;
  color:#aaa;
  font-size:20px;
   background:#333333aa;
   padding:10px;
  border-radius: 5px;
}

.pd-weather{
  display:flex;
  align-items: center;
  color:#ddd;
  position: absolute;
  left:10px;
  bottom:10px;

 background:#333333aa;
  height:60px;
  padding:10px;
  border-radius: 5px;
}

.pd-time{
   display:flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom:10px;
  right:10px;
  height:60px;
  background:#333333aa;
  padding:10px;
  border-radius: 5px;

}

.pd-ip-mask{
  position: absolute;
  left:0;
  bottom:0;
  right:0;
  top:0;
  background:#33333377;
}

.pd-ip-title{
  font-size:20px;
  color:#fff;
  text-shadow: none;

}
.pd-ip-sub{
  font-size:14px;
  color:#ddd;
}

.pd-ip-deg{
  font-weight: bold;
  font-size:40px;
}

.pm-glass{
  .pm-ip{
    opacity:0.8;
  }
}
</style>
